import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import clsx from 'clsx';
import React from 'react';
import { type FieldValues, type SubmitHandler, type UseFormProps, type UseFormReturn, useForm } from 'react-hook-form';
import { type z } from 'zod';

type FormProps<Schema extends z.ZodType<unknown, any, any>, TFormValues extends FieldValues> = {
	className?: string;
	onSubmit: SubmitHandler<TFormValues>;
	children: (methods: UseFormReturn<TFormValues>) => React.ReactNode;
	options?: UseFormProps<TFormValues>;
	id?: string;
	schema: Schema;
	preventDefault?: boolean;
	stopPropagation?: boolean;
};

export const Form = <Schema extends z.ZodType<unknown, any, any>, TFormValues extends FieldValues>({
	onSubmit,
	children,
	className,
	options,
	id,
	schema,
	preventDefault,
	stopPropagation
}: FormProps<Schema, TFormValues>) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const methods = useForm({ ...options, resolver: schema && standardSchemaResolver(schema as z.ZodType<unknown, any, any>) });

	return (
		<form
			className={clsx('flow', className)}
			onSubmit={(e) => {
				if (preventDefault) {
					e.preventDefault();
				}
				if (stopPropagation) {
					e.stopPropagation();
				}
				methods.handleSubmit(onSubmit)(e);
			}}
			id={id}
		>
			{children(methods)}
		</form>
	);
};
